// extracted by mini-css-extract-plugin
module.exports = {"container":"plan_container__2O6Op","key":"plan_key__3t9LO","value":"plan_value__39EKF","root":"plan_root__2lvEt","pricingBtn":"plan_pricingBtn__be4k3"};